import React from 'react';
import { useAtom, useSetAtom } from 'jotai';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { visionUserModeAtom, toggleVisionUserModeAtom, authUserAtom } from '../Services/store/atoms';
import { useSideBar } from './SideBar/SideBarContext';
import { PiEyeLight, PiEyeSlashLight } from 'react-icons/pi';

const SideBarVisionModeToggle = () => {
  const [visionUserMode] = useAtom(visionUserModeAtom);
  const [authUser] = useAtom(authUserAtom);
  const toggleVisionUserMode = useSetAtom(toggleVisionUserModeAtom);
  const { open } = useSideBar();
  const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 1024;
  const showText = open || !isDesktop;
  const history = useHistory();

  const handleToggle = () => {
    const newVisionMode = !visionUserMode;
    axios.post('/api/v1/admin/toggle-view-as-user', { view_as_user: newVisionMode ? '1' : '0' }, {
      headers: { Authorization: `Bearer ${authUser?.token}` }
    }).catch(() => {});
    toggleVisionUserMode();
    if (!visionUserMode) history.push('/');
    else history.push('/admin');
  };

  return (
    <button
      onClick={handleToggle}
      title={visionUserMode ? 'Salir del Modo Usuario' : 'Ver como Usuario'}
      className={`group relative flex items-center justify-center gap-3 rounded-full border px-3 py-2 text-sm transition-all duration-200 ease-out w-full active:scale-[0.98] ${
        visionUserMode
          ? 'border-rose-300 dark:border-rose-700 bg-rose-50 dark:bg-rose-900/30 text-rose-700 dark:text-rose-300 font-medium'
          : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-800'
      }`}
    >
      <span className={`shrink-0 text-lg transition-all duration-200 ease-out ${visionUserMode ? 'text-rose-500 scale-110' : 'text-gray-400 dark:text-gray-500 group-hover:text-gray-600 dark:group-hover:text-gray-300 group-hover:scale-105'}`}>
        {visionUserMode ? <PiEyeSlashLight className="text-xl" /> : <PiEyeLight className="text-xl" />}
      </span>
      {showText && <span className={`truncate ${visionUserMode ? '' : 'font-medium'}`}>{visionUserMode ? 'Modo Usuario ON' : 'Modo Usuario'}</span>}
    </button>
  );
};

export default SideBarVisionModeToggle;
